import { memo, ReactNode, useEffect, useRef } from "react";
import type { Swiper as SwiperClass } from "swiper";
import type { SwiperModule } from "swiper/types";
import createStoriesSlider, {
  type StoriesSliderControls,
} from "./stories-slider.esm.js";
import IconXMark from "@/assets/icons/x-mark.svg?react";
import VibratingButton from "@/components/base/button/VibratingButton.tsx";

type StoriesSliderProps = {
  swiper?: typeof SwiperClass;
  effectCube?: SwiperModule;
  enabled?: boolean;
  autoplayDuration?: number;
  avatar?: string;
  userLink?: string;
  name?: string;
  date?: string;
  closeButton?: boolean;
  duration?: number;
  onCloseButtonClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onSlidesIndexesChange?: (...args: any[]) => void;
  onStoriesSlider?: (slider: any) => void;
  onAutoplayStart?: (...args: any[]) => void;
  onAutoplayStop?: (...args: any[]) => void;
  children: {
    avatar?: ReactNode;
    name?: ReactNode;
    date?: ReactNode;
    content?: ReactNode;
  };
};

const Story = memo(
  ({
    swiper,
    effectCube,
    enabled = true,
    autoplayDuration = 5000,
    closeButton,
    duration,
    onCloseButtonClick,
    onSlidesIndexesChange,
    onStoriesSlider,
    onAutoplayStart,
    onAutoplayStop,
    children,
  }: StoriesSliderProps) => {
    const elRef = useRef<HTMLDivElement | null>(null);
    const storiesSliderRef = useRef<StoriesSliderControls | null>(null);

    function onStoriesSeen(index: number) {
      console.log(index, "~ko'rilgan istoriya");
    }

    useEffect(() => {
      storiesSliderRef.current = createStoriesSlider(elRef.current, {
        Swiper: swiper,
        EffectCube: effectCube,
        enabled,
        autoplayDuration,
        onSlidesIndexesChange,
        onAutoplayStart,
        onAutoplayStop,
        storiesSeen: onStoriesSeen,
      });

      if (onStoriesSlider) {
        onStoriesSlider(storiesSliderRef.current);
      }

      return () => {
        if (storiesSliderRef.current && storiesSliderRef.current.destroy) {
          storiesSliderRef.current.destroy();
        }
      };
    }, []);

    return (
      <div
        ref={elRef}
        className="stories-slider swiper-slide aspect-[9/16]"
        data-duration={duration}
      >
        {closeButton && (
          <div className="stories-slider-actions">
            <VibratingButton
              className="stories-slider-close-button"
              onClick={onCloseButtonClick}
            >
              <IconXMark width="20" height="20" className="text-white" />
            </VibratingButton>
          </div>
        )}
        <div className="stories-slider-content">{children.content}</div>
      </div>
    );
  }
);

export default Story;

// import { ReactNode, useEffect, useRef } from "react";
// import Swiper from "swiper";
// import { EffectCube } from "swiper/modules";
// import IconXMark from "@/assets/icons/x-mark.svg?react";
// import useStoriesSlider from "./useStoryInstance";

// interface StoryProps {
//   swiper?: typeof Swiper;
//   effectCube?: typeof EffectCube;
//   enabled?: boolean;
//   autoplayDuration?: number;
//   avatar?: string;
//   userLink?: string;
//   name?: string;
//   date?: string;
//   closeButton?: boolean;
//   duration?: number;
//   onCloseButtonClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
//   onSlidesIndexesChange?: (mainIndex: number, subIndex: number) => void;
//   onStoriesSlider?: (slider: any) => void;
//   onAutoplayStart?: (swiper: Swiper) => void;
//   onAutoplayStop?: (swiper: Swiper) => void;
//   children: {
//     avatar?: ReactNode;
//     name?: ReactNode;
//     date?: ReactNode;
//     content?: ReactNode;
//   };
// }

// const Story = ({
//   swiper,
//   effectCube,
//   enabled = true,
//   autoplayDuration = 5000,
//   avatar,
//   userLink,
//   name,
//   date,
//   closeButton,
//   duration,
//   onCloseButtonClick,
//   onSlidesIndexesChange,
//   onStoriesSlider,
//   onAutoplayStart,
//   onAutoplayStop,
//   children,
// }: StoryProps) => {
//   const elRef = useRef<HTMLDivElement | null>(null);

//   function onStoriesSeen(index: number) {
//     console.log(index, "~ko'rilgan istoriya");
//   }

//   const storiesSlider = useStoriesSlider(elRef, {
//     EffectCube: effectCube,
//     enabled,
//     autoplayDuration,
//     onSlidesIndexesChange,
//     onAutoplayStart,
//     onAutoplayStop,
//     storiesSeen: onStoriesSeen,
//   });

//   useEffect(() => {
//     if (onStoriesSlider) {
//       onStoriesSlider(storiesSlider);
//     }
//   }, [storiesSlider, onStoriesSlider]);

//   return (
//     <div
//       ref={elRef}
//       className="stories-slider swiper-slide"
//       data-duration={duration}
//     >
//       {closeButton && (
//         <div className="stories-slider-actions">
//           <button
//             className="stories-slider-close-button"
//             onClick={onCloseButtonClick}
//           >
//             <IconXMark width="20" height="20" className="text-white" />
//           </button>
//         </div>
//       )}
//       <div className="stories-slider-content">{children.content}</div>
//     </div>
//   );
// };

// export default Story;
